import { render, staticRenderFns } from "./PagePromocodes.vue?vue&type=template&id=da8df1c6&"
import script from "./PagePromocodes.vue?vue&type=script&lang=js&"
export * from "./PagePromocodes.vue?vue&type=script&lang=js&"
import style0 from "./PagePromocodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports